module.exports = new __parcel__URL__("Planet_B_teaser_en.25f5cca1.webp").toString();